// Navigation.jsx
import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom'; // 'useLocation' hook provides the current URL pathname, which can be used to determine the active menu dynamically.
import './NavBar.css';
// import chm_logo from '../assets/CHM-logo.png';
import chm_logo from '../assets/Artboard 1Bonus.png'; //updated logo
import globalVariables from "../custom_libraries/globalVariables";
import urls from '../custom_libraries/urls';
import ProfileIcon from '../assets/icons8-user-profile-32.png';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "../assets/icons8-home-48.png";
import DeviceManagerIcon from "../assets/icons8-networking-manager-48.png";
import MapMarkerIcon from "../assets/icons8-map-marker-30.png";
import SettingsIcon from "../assets/icons8-settings-32.png";
import CctvIcon from "../assets/icons8-cctv-50.png";
import AnalyticsIcon from "../assets/icons8-combo-chart-50.png"
import LogoutIcon from "../assets/icons8-logout-64.png";
import HamburgerIcon from "../assets/icons8-fries-menu-48.png";
// import UserAccounts from "./Settings/UserAccounts";
import UserSettingsIcon from "../assets/icons8-management-48.png";
import '../Pages/Settings/SubNavbar.css';
// import AlertTabIcon from '../assets/icons8-alert-error-64.png';
import { signOut } from "../custom_libraries/auth";
import withNavigate from '../Global_files/WithNavigate'; 
import ProfileIcon2 from '../assets/icons8-admin-user-profile-48.png';
import DialogBox from './DialogBox';
import AlertTabIcon from '../assets/icons8-alert-error-64.png';
import PlaybackIcon from "../assets/icons8-playback-24.png"; 
import NotesIcon from '@mui/icons-material/Notes';

const Navigation = ({ navigate }) => {
  const location = useLocation();
  // const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [formData, setFormData] = useState({
                                            username:'',
                                            first_name: '',
                                            last_name: '',
                                            phoneno: '',
                                            email: '',
                                            user_passcode: '',
                                          });
  const[successRes, setSuccessRes] = useState(false)
  const[errorRes, setErrorRes] = useState(false)
  const [userType, setUserType] = useState('');
  const [activeSubTab, setActiveSubTab] = useState("Add User");
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subtitle: "",
    onConfirm: null,
  });
  const [isLogoDialogOpen, setIsLogoDialogOpen] = useState(false);
const [selectedLogoFile, setSelectedLogoFile] = useState(null);
const [uploading, setUploading] = useState(false);
const [fileName, setFileName] = useState("");
const [userLogo, setUserLogo] = useState(
  localStorage.getItem("USER_LOGO") || chm_logo
);

const [show, setShow] = useState(false);

  useEffect(() => {
    // Retrieve the user type from localStorage
    const storedUserType = localStorage.getItem(globalVariables.USER_TYPE);
    setUserType(storedUserType);

    const userId = localStorage.getItem(globalVariables.USER_ID);
      if (userId) {
    fetchUserProfile(userId);   // already present
    fetchUserLogo();            //  Added THIS for getting custom logo
   }

    if (successRes || errorRes) {
      const timer = setTimeout(() => {
        setSuccessRes(false);
        setErrorRes(false);
        setIsDialogOpen(false);
      }, 2400); // 2 seconds

      // Cleanup the timer when the component unmounts or dependencies change
      return () => clearTimeout(timer);
    }
  }, [successRes, errorRes]); // Dependencies: triggers when `Success` or `error` changes


  // Fetch user profile details
  const fetchUserProfile = async (id) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      let url = urls.GET_PROFILE_DETAILS(id);
      console.log("GET_PROFILE_DETAILS --url----", url);
      const response = await fetch(urls.GET_PROFILE_DETAILS(id), {
        headers: headers,
    }); // Replace with actual URL
      console.log("respp------fetchUserProfile----", response);
      const data = await response.json();
      console.log("data------fetchUserProfile----", data);
      const userData = data.data[0];
      setFormData({
        username: userData.username,
        first_name: userData.first_name,
        last_name: userData.last_name,
        phoneno: userData.phoneno,
        email: userData.email,
        user_passcode: userData.user_passcode, // Include passcode if needed
      });
      console.log("sms_service fetchUserProfile:", userData.sms_service);
      localStorage.setItem(globalVariables.USER_EMAIL, userData.email || ""); // Store email in localStorage
      localStorage.setItem(globalVariables.SMS_SERVICE_PERMISSION, userData.sms_service); // Store SMS service permission in localStorage
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };


  // Fetch user profile details
  const UpdateUserProfile = async (id, updatedData) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      const url = `${urls.UPDATE_PROFILE_DETAILS(id)}`;
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`, // Optional if needed
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        throw new Error('Failed to update profile');
      }

      const data = await response.json();
      console.log('Profile updated successfully:', data);
      if(data.data && data.data.length > 0){
        setSuccessRes(true);
        setErrorRes(false);
                
      }
      else{
        setErrorRes(true);
      }
    } catch (error) {
      console.error('Error updating user profile:', error);
    }
  };

  const DeleteUser = async () => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      // let headers = {
      //     'content-type': 'application/json',
      //     'Authorization': `Bearer ${access_tocken}`
      // }
      // console.log("DeleteUser id url---- :", urls.DELETE_USER(id)); // Update URL for fetching sites
      const url = `${urls.DELETE_LOGGED_IN_USER}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`, // Optional if needed
        },
      });
      //console.log("----DeleteUser----url---------", url);
      console.log("----DeleteUser----url---------", response);
      if (response.ok){
            navigate("/")
      }
      else {
        alert("Error deleting this account, try again later");
        closeDialog();
      }
      
  } catch (error) {
      console.error("Error in getSitesList:", error);
      
  }
  }


  const handleDialogToggle = () => {
    const id = localStorage.getItem(globalVariables.USER_ID);

    setIsDialogOpen((prev) => !prev);
    if (id) {
      fetchUserProfile(id); // Pass the id to the fetchUserProfile function
      fetchUserLogo();

    }
  };

   const handleReleaseDialogToggle = () => {
    setShow((prev) => !prev);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const { phoneno, email } = formData;

    // Phone number validation (10 digits)
    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(phoneno)) {
        alert("Please enter a valid 10-digit phone number.");
        return;
    }

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
        alert("Please enter a valid email address.");
        return;
    }
    console.log('Form submitted:', formData);
    const id = localStorage.getItem(globalVariables.USER_ID);
    if (id) {
      UpdateUserProfile(id, formData); // Send updated form data to the server
    }
    // Add form submission logic here
  };

  const handleDeleteUser = (e) => {
    // e.preventDefault();
    // console.log('Form submitted:', formData);
    // const id = localStorage.getItem(globalVariables.USER_ID);
    // if (id) {
    //   DeleteUser(id); // Send updated form data to the server
    // }
    DeleteUser();
  };

  
  // const isActive = (path) => location.pathname === path;
  const handleLogout = () => {
    // Perform clearing localStorage/sessionStorage.
    
    signOut(navigate);
    localStorage.removeItem(globalVariables.AUTH_TOKEN); // Example
    console.log("User logged out from:", location.pathname);
  };


  // Updated isActive function
  const isActive = (path) => location.pathname.startsWith(path);

  // Toggle the sidebar collapse state.
  const toggleNavbar = () => {
    setIsCollapsed((prevState) => {
      console.log("Toggling navbar:", !prevState);
      return !prevState;
    });
  };
   
  const openDialog = (onConfirm) => {
    // if (selectedTemplateID === 1) {
    //   setDeleteCheck1(true);
    //   return;
    // }
    // if (selectedTemplateID === null) {
    //   setDeleteCheck2(true);
    //   return;
    // }
    setConfirmDialog({
      isOpen: true,
      title: "Confirm Action",
      subtitle: "Are you sure you want to delete the account? This will delete all the data and sites associated with this account and cannot be recovered later.",
      onConfirm,
    });
  };

  const closeDialog = () => {
    setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
  };

  // Open popup
const handleLogoClick = () => {
  setIsLogoDialogOpen(true);
};

// Capture selected file
 // ⭐ UPDATE LOGO INSTANTLY WHEN FILE SELECTED
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setSelectedLogoFile(file);
    setFileName(file.name);

    const reader = new FileReader();
    reader.onloadend = () => {
      localStorage.setItem("USER_LOGO", reader.result);
      setUserLogo(reader.result);     // 🔥 INSTANT UPDATE, NO WAITING
    };
    reader.readAsDataURL(file);
  };

const handleSaveLogoToDB = async () => {
  if (!selectedLogoFile) {
    alert("Please select a logo file first!");
    return;
  }

  // ⭐ INSTANT UI UPDATE — BEFORE UPLOADING (important)
  const reader = new FileReader();
  reader.onloadend = () => {
    localStorage.setItem("USER_LOGO", reader.result); // Base64 stored
    setUserLogo(reader.result); // navbar updates instantly
  };
  reader.readAsDataURL(selectedLogoFile);

  try {
    setUploading(true);
    const formData = new FormData();
    formData.append("logo", selectedLogoFile);

    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const userId = localStorage.getItem(globalVariables.USER_ID);
    formData.append("user", userId);
    formData.append("image", selectedLogoFile);

    const response = await fetch(urls.SAVE_USER_LOGO, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      body: formData,
    });

    const result = await response.json();

    if (response.ok) {
      alert("Logo uploaded successfully!");
      // ❌ REMOVE fetchUserLogo(); — no longer needed
      setIsLogoDialogOpen(false);
      setFileName("");
      setSelectedLogoFile(null);
    } else {
      console.error(result);
      alert("Failed to upload logo. Please try again later.");
    }

  } catch (err) {
    console.error("Error uploading logo:", err);
    alert("Error uploading logo. Please check your network.");
  } finally {
    setUploading(false);
  }
};



const fetchUserLogo = async () => {
  try {
    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const userId = localStorage.getItem(globalVariables.USER_ID);

    const response = await fetch(urls.GET_USER_LOGOS, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });

    const data = await response.json();
    let logoRecord = null;
    
     if (Array.isArray(data)) {
      logoRecord = data.find(item => item.user === userId);
    } else if (data.user === userId) {
      logoRecord = data;
    }

    if (!logoRecord) return;

     // Convert the logo into BASE64
    const imgResponse = await fetch(logoRecord.image_url);
    const blob = await imgResponse.blob();

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Image = reader.result;    // THIS IS FAST
      localStorage.setItem("USER_LOGO_BASE64", base64Image);
      setUserLogo(base64Image);
    };
    reader.readAsDataURL(blob);

  } catch (err) {
    console.error("Error fetching user logo:", err);
  }
};



  let user_name = localStorage.getItem(globalVariables.USER_NAME);
  return (
    <div className={`navbar-container ${isCollapsed ? "collapsed" : ""}`}>
      <nav className="navbar" >
        <button
          type="button"
          className="mobile-navbar-toggle"
          onClick={toggleNavbar}
          aria-label={isCollapsed ? "Expand navigation" : "Collapse navigation"}
          aria-expanded={!isCollapsed}
        >
          <span aria-hidden="true">{isCollapsed ? "›" : "‹"}</span>
        </button>
        {userType === 'DealerUser' && (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
            // onClick={() => navigate("/system-overview")}
            onClick={handleLogoClick}
          >
              <img
              src={userLogo || chm_logo} 
              alt="logo"
              width="70px"
              height="60px"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
          </span>
        )}
          <>
            <span>
              <ul>
              {/* DealerUser: Access to all tabs */}
              {(userType === 'DealerUser' || userType === 'CustomerUser' || userType === 'TechnicianUser') && (
                  <li className={isActive('/system-overview') ? 'active' : ''}>
                    <Link to="/system-overview" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={HomeIcon} alt='home-icon' width="31px"/>
                      <span>System<br/> Overview</span>
                      {/* <span>Overview</span> */}
                    </Link>
                  </li>
              )}
              
              {(userType === 'DealerUser' || userType === 'TechnicianUser') && (
                <>
                  <li className={isActive('/showDevices') ? 'active' : ''}>
                    <Link to="/showDevices" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={CctvIcon} alt='map-marker' width="31px"/>
                      <span>Sites</span>
                    </Link>
                  </li>

                    <li className={isActive('/alerts') ? 'active' : ''}>
                    <Link to="/alerts" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={AlertTabIcon} alt='map-marker' width="31px"/>
                      <span>Alerts</span>
                    </Link>
                    </li>

                    {/* <li className={isActive('/stream-playback') ? 'active' : ''}>
                    <Link to="/stream-playback" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={PlaybackIcon} alt='stream-playback' width="31px"/>
                      <span>Playback</span>
                    </Link>
                  </li> */}

                  <li className={isActive('/analytics') ? 'active' : ''}>
                  <Link to="/analytics" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                    <img src={AnalyticsIcon} alt='map-marker' width="31px"/>
                    <span>Analytics</span>
                  </Link>
                  </li>
                </>
              )}
              {(userType === 'DealerUser'|| userType === 'CustomerUser') && (
                <>
                  <li className={isActive('/settings') ? 'active' : ''} onClick={() => setActiveSubTab("Schedule Time")}>
                    <Link to="/settings" style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                      <img src={SettingsIcon} alt='setting-icon' width="31px" />
                      <span>Settings</span>
                    </Link>
                  </li>
                </> 
              )} 
              {userType === "DealerUser" && (
                  <>
                    <li className={isActive("/userAccounts") ? "active" : ""} onClick={() => setActiveSubTab("Add User")}>
                      <Link to="/userAccounts" style={{ display: "flex", flexDirection:'column', alignItems: "center" }}>
                        <img src={UserSettingsIcon} alt="setting-icon" width="31px" />
                        <span>User<br/>Management</span>
                      </Link>
                    </li>
                  </>
                )}
                
              </ul>
            </span>
            <div className="user-info" >
              <div>
                <li onClick={() => setShow(true)} style={{display:"flex", flexDirection: "column", alignItems:"center", cursor:"pointer"}}>
                  <NotesIcon width="31px" />
                  <span style={{fontSize:'14px'}}>Release Notes</span>
                </li>
              </div><br/>
              <div onClick={handleDialogToggle}>
                <span style={{ display: 'flex', alignItems: 'center', flexDirection:'column', cursor:'pointer' }}>
                  <img src={ProfileIcon} alt="profile-icon" width="33px" />

                  <span style={{color: 'rgb(41, 223, 255)', fontSize:'17px'}}>{user_name}</span>
                </span>
              </div><br/>

              <div style={{display: 'flex', alignItems: "center", flexDirection:'column'}}>
                {/* <Link to="/" style={{ textDecoration: "none" }}> */}
                <img src={LogoutIcon} alt='logouticon' width='31px' onClick={handleLogout} style={{cursor:'pointer'}}></img>
                {/* </Link> */}
                <span>Logout</span>
              </div>
            </div>
          </>

        {/* Dialog Box */}
        {isDialogOpen && (
          <div
            style={{
              position: 'fixed',  // Use fixed to position it relative to the viewport
              top: '0',           // Align to the top
              right: '0',         // Align to the extreme right
              backgroundColor: '#32394a',
              padding: '0px 15px',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              zIndex: '1000',
              color: 'White',
              width: '240px',
              height: '100vh',  // Full height to cover the right side
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              // justifyContent: 'center'
            }}
          >
            <button
              onClick={handleDialogToggle}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "#d6d6d6d2",
                border: "none",
                fontSize: "18px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              ✖
            </button>
            <span style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', color:'#bed6eb', paddingBottom:'5px'}}>
              <h3>Update Profile</h3>
              <img src={ProfileIcon2} alt='profile-icon2' width="40px" height="40px"/>
            </span>
            <form onSubmit={handleSubmit} style={{width:'100%', padding:'2px', display:'flex', flexDirection: 'column', gap:'8px'}}>
              {/* <div style={{display:'flex', justifyContent:'center', gap:'5px'}}> */}
              {successRes && (
                  <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                      Profile is updated.
                  </Alert>
              )}
              {errorRes && (
                  <Alert severity="error">
                      Server Error! Profile was not updated.
                  </Alert>
              )}
              <div>
                <label style={{color:'#c4cfd8'}}>User name:</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  // onChange={handleInputChange}
                  readOnly
                  style={{width:'90%', height:'20px', fontSize:'14px'}}
                  required
                />
              </div>
              <div>
                <label style={{color:'#c4cfd8'}}>First name:</label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  style={{width:'90%', height:'20px', fontSize:'14px'}}
                  required
                />
              </div>
              <div>
                <label style={{color:'#c4cfd8'}}>Last name:</label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleInputChange}
                  style={{width:'90%', height:'20px', fontSize:'14px'}}
                  required
                />
              </div>
              <div>
                <label style={{color:'#c4cfd8'}}>Phone no:</label>
                <input
                  type="text"
                  name="phoneno"
                  value={formData.phoneno}
                  onChange={handleInputChange}
                  style={{width:'90%', height:'20px', fontSize:'14px'}}
                  required
                />
              </div>
              <div>
                <label style={{color:'#c4cfd8'}}>Email id:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  // onChange={handleInputChange}
                  readOnly
                  style={{width:'90%', height:'20px', fontSize:'14px'}}
                  required
                />
              </div>
              {/* {userType === 'TechnicianUser' && ( */}
              <div>
                <label style={{color:'#c4cfd8'}}>Operator passkey:</label>
                <input
                  readOnly
                  type="text" 
                  name="user_passcode"
                  value={formData.user_passcode || 'N/A'}
                  // onChange={handleInputChange}
                  style={{width:'90%', height:'20px', fontSize:'14px'}}
                  // required
                />
              </div>
              {/* )} */}
              <div style={{ marginTop: '10px', display: "flex", alignItems: "center", gap:"5px" }}>
                <Button type="submit"
                id="rowsPerPageButton" 
                style={{fontSize:'12px', fontWeight:'bold', height: "34px",display: "flex", alignItems: "center", margin:'0px'}}
                >Submit</Button>
                <Button
                  type="button"
                  id="clearUserLogButton" 
                  style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px'}}
                  onClick={handleDialogToggle}
                >
                  Cancel
                </Button>
                
              </div>
              
            </form>
            <div style={{marginTop: "60%", marginBottom: "10px"}}> 
                <span style={{display:'flex',justifyContent:'center', alignItems:'center', textAlign:'center', color:'#ee4845'}}>
                  <h3>Delete Account?</h3>
                </span>
                <Button
                    type="button"
                    id="clearUserLogButton"
                    style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px'}}
                    onClick={() => openDialog(handleDeleteUser)}
                    // onClick={handleDeleteUser}
                >
                  Delete Account
                </Button>
            </div>
          </div>
        )}

        {/* Overlay (optional) */}
        {isDialogOpen && (
          <div
            style={{
              position: 'fixed',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              zIndex: '900',
            }}
            onClick={handleDialogToggle}
          ></div>
        )}

        {show && (
          <div
            onClick={handleReleaseDialogToggle} // clicking outside closes modal
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.5)", // overlay
              zIndex: 999
            }}
          >
          <div
             onClick={(e) => e.stopPropagation()} // prevents click from bubbling
            style={{
              position: 'fixed',  // Use fixed to position it relative to the viewport
              top: '6%',           // Align to the top
              left: '35%',         // Align to the extreme right
              backgroundColor: '#485269',
              padding: '0px 15px',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              zIndex: '1000',
              // color: 'White',
              width: '640px',
              height: '90vh',  // Full height to cover the right side
              // display: 'flex',
              // flexDirection: 'column',
              alignItems: 'center',
              // justifyContent: 'center'
            }}
          >
        <iframe
          src="https://eyeon8i.com/release-notes"
          width="100%"
          height="90%"
          title="Release Notes"
          backgroundColor="#32394a"
          color='#fff'
          style={{ border: "none", marginTop: "10px" }}
        />
        <Button
          type="button"
          id="clearUserLogButton" 
          style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px'}}
          onClick={handleReleaseDialogToggle}
        >
          Close
        </Button>
          </div>
        </div>
      )}

        <DialogBox
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
          onConfirm={confirmDialog.onConfirm}
          onCancel={closeDialog}
        />

        {isLogoDialogOpen && (
          <div
            style={{
                    position: 'fixed',  // Use fixed to position it relative to the viewport
                    top: '0',           // Align to the top
                    left: '3px',         // Align to the extreme left
                    backgroundColor: '#32394a',
                    // padding: '0px 15px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                    zIndex: '1000',
                    color: 'white',
                    width: '290px',
                    height: '100vh',  // Full height to cover the right side
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
            }}
            onClick={() => setIsLogoDialogOpen(false)}
          >
            <div
              
              onClick={(e) => e.stopPropagation()}
              style={{paddingLeft:'35px'}}
            >
              <h3 style={{ color: "#dae0e4" }}>Upload Logo</h3>

              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleLogoUpload}
                style={{ marginTop: "10px" }}
              />
                  {fileName && (
                  <span style={{ fontSize: "12px", color: "#dae0e4", maxWidth: "130px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                    {fileName}
                  </span>
                )}
              <div style={{ marginTop: "15px", display: "flex", justifyContent: "center", gap: "8px" }}>
                <Button
                  variant="contained"
                  onClick={handleSaveLogoToDB}
                  disabled={uploading}
                  style={{ fontSize: "12px", fontWeight: "bold" }}
                >
                  {uploading ? "Saving..." : "Save"}
                </Button>

                <Button
                  variant="outlined"
                  onClick={() => setIsLogoDialogOpen(false)}
                  style={{ fontSize: "12px", fontWeight: "bold" }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}

      </nav>
    </div>
  );
};

export default withNavigate(Navigation);
